<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { z } from 'zod'

import type { AuthOtpResponse } from '@supabase/supabase-js'

definePageMeta({
  authType: 'guest',
  layoutProps: {
    solidHeader: true,
  },
})

const supabase = useSupabase()
const signInResponse = ref<null | AuthOtpResponse>(null)
const loginDisabled = ref(false)

const { handleSubmit } = useForm({
  validationSchema: toTypedSchema(
    z.object({
      email: z.string().email({ message: 'Ungültige E-Mail-Adresse' }),
    }),
  ),
  initialValues: {
    email: '',
  },
})

const submit = handleSubmit(async (values) => {
  loginDisabled.value = true

  signInResponse.value = await supabase.auth.signInWithOtp({
    email: values.email,
    options: {
      emailRedirectTo: `${useRuntimeConfig().public.origin}/buchung/uebersicht`,
      shouldCreateUser: false,
    },
  })

  if (signInResponse.value.error) {
    loginDisabled.value = false
    console.error(signInResponse.value.error)
  }
})
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-8 py-12">
    <img src="/logo_with_subtitle.png" alt="atelierluft Logo" class="w-64" />
    <form
      class="flex w-full max-w-xl flex-col gap-12 rounded-xl border bg-white p-8 shadow-md"
      @submit.enter.prevent="(event) => submit(event)"
    >
      <div class="flex flex-col gap-4">
        <h1 class="text-2xl font-bold uppercase text-al-primary">Login</h1>
        <AlTextInput name="email" label="Mail-Adresse" :input="{ type: 'email' }" required />
        <button
          :disabled="loginDisabled"
          type="submit"
          class="self-end rounded-md bg-al-primary px-3 py-2 text-sm font-bold uppercase text-white disabled:opacity-50"
        >
          Anmelden
        </button>
      </div>
      <div v-if="signInResponse">
        <div class="flex gap-4" :class="signInResponse?.error ? 'text-red-500' : 'text-stone-500'">
          <UIcon
            :name="
              signInResponse?.error
                ? 'i-heroicons-exclamation-circle'
                : 'i-heroicons-information-circle'
            "
            class="flex-none text-2xl"
          />
          <p v-if="signInResponse?.error && signInResponse?.error.name === 'AuthApiError'">
            Es existiert kein Nutzer mit dieser Mail-Adresse.
          </p>
          <p v-else>
            Wir haben Dir eine Mail mit einem Bestätigungslink geschickt. Bitte verifiziere Dich
            über diesen Link, um Dich anzumelden und Deine Buchungen einzusehen.
          </p>
        </div>
      </div>
    </form>
  </div>
</template>
